<template>
  <div class="swiper_banner_wrap">
    <van-popup v-model="isShow" :close-on-click-overlay="false">
      <div class="v_box">
        <div class="swiper_banner_box" :class="isDisabled && 'lock_style'">
          <swiper
            :class="['swiper-wrapper', { 'swiper-no-swiping': sData.length <= 1 }]"
            :options="swiperOptions"
          >
            <swiper-slide v-for="(item, index) in sData" :key="index" class="swiper-item">
              <div class="swiper-item-box">
                <div class="icon_box">
                  <img class="icon_img" :src="item.iconUrl" alt="benefit" />
                  <img
                    v-if="isDisabled"
                    class="icon_lock"
                    src="https://img0.didiglobal.com/static/soda_public/do1_FVluH56sfUBQdyQDMTU2"
                    alt="lock"
                  />
                </div>
                <div class="info_box">
                  <h5 class="hyphenate-text">{{ item.title }}</h5>
                  <p class="hyphenate-text" :class="item.birthday && 'birthday'">
                    {{ item.detailedDesc }}
                  </p>
                  <p v-if="item.birthday">
                    {{ $t('FoodC_birthday_teJB_YsTQ', { date: item.birthday }) }}
                  </p>
                  <!-- 操作 -->
                  <template v-if="!isDisabled">
                    <div v-if="item.receiveStatus === 0" class="btn" @click.stop="goSettingBir">
                      {{ $t('FoodC_birthday_MdbO_KlNx') }}
                    </div>
                    <div
                      v-if="item.receiveStatus === 1"
                      class="btn"
                      @click.stop="getBirthdayCoupons"
                    >
                      {{ $t('FoodC_birthday_hJRO_UaMS') }}
                    </div>
                    <div v-if="item.receiveStatus === 3" class="btn" @click.stop="goCoupons">
                      {{ $t('FoodC_birthday_vcey_tequ') }}
                    </div>
                    <div v-if="item.clickUrl" class="btn" @click.stop="jumpBenefit(item)">
                      {{ jumpBtnName(item) }}
                    </div>
                  </template>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div slot="pagination" class="swiper-pagination banner_pagination"></div>
          <div class="close_btn" @click="handleClose">
            <i class="icon-v3_outline_close"></i>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import { Swiper as SwiperClass, Pagination, EffectCoverflow } from 'swiper/js/swiper.esm'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
import 'swiper/css/swiper.css'
import { Popup } from 'vant'
import mixin from '@/page/member/mixins.js'

SwiperClass.use([Pagination, EffectCoverflow])
Vue.use(getAwesomeSwiper(SwiperClass))
Vue.use(Popup)

export default {
  name: 'MemberSwiperBanner',
  mixins: [mixin],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    sData: {
      type: Array,
      default: () => [],
    },
    initialSlide: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isShow: true,
    }
  },
  computed: {
    ...mapState(['membership', 'globalParams']),
    isDisabled() {
      return this.isNewUserStatus || this.membership?.status === 1
    },
    swiperOptions() {
      const _that = this
      return {
        effect: 'coverflow',
        loop: true,
        slidesPerView: 1.25,
        centeredSlides: true,
        initialSlide: this.initialSlide,
        coverflowEffect: {
          rotate: 30,
          // stretch: -10,
          depth: 100,
          // modifier: 1,
          slideShadows: false,
        },
        observer: true,
        observeParents: true,
        spaceBetween: 20,
        pagination: {
          el: '.banner_pagination',
        },
        on: {
          slideChangeTransitionEnd() {
            _that.change(this.realIndex)
          },
        },
      }
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(nVal) {
        // this.isShow = nVal
      },
    },
  },
  methods: {
    /** @desc swiper滑动 */
    change(index) {
      console.log('change ~ index:', index)
    },
    /** @desc swiper组件关闭 */
    handleClose() {
      this.$emit('close')
    },
    // 设置生日
    goSettingBir() {
      this.$emit('goSettingBir')
    },
    // 领取生日券
    getBirthdayCoupons() {
      this.$emit('getBirthdayCoupons')
    },
    // 查看优惠券
    goCoupons() {
      this.$emit('goCoupons')
    },
    // 跳转
    jumpBenefit(data) {
      this.$emit('jumpBenefit', data)
    },
    jumpBtnName(data) {
      if (data.clickUrl) {
        return this.$t('FoodC_url_reaV_LXaO')
      }
      return this.$t('FoodC_shoprank_Qwab_yWBb')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/mixin.scss';

.swiper_banner_wrap {
  .van-popup {
    background-color: unset;
  }
}
.v_box {
  position: relative;
  height: 100vh;
  width: 100vw;
}
.swiper_banner_box {
  position: absolute;
  left: 0;
  top: 18%;
  width: 750px;
  height: 814px;
  &.lock_style {
    height: 728px;
  }

  ::v-deep .swiper-pagination {
    font-size: 0;
    height: 60px;
    bottom: -100px;
    width: 560px;
    left: calc(50% - 280px);
    .swiper-pagination-bullet {
      margin-right: 10px;
      width: 20px;
      height: 4px;
      opacity: 0.24;
      background: #fff !important;
      border-radius: 16px !important;
    }
    .swiper-pagination-bullet {
      opacity: 0.5;
    }
    .swiper-pagination-bullet-active {
      opacity: 1;
    }
  }
  .swiper-item-box {
    width: 590px;
    // height: 814px;
    height: 100%;
    border-radius: 40px;
    overflow: hidden;
    background: #fff;
    .icon_box {
      position: relative;
      height: 320px;
      width: 100%;
      background: url('../imgs/benefit_bg.png') no-repeat;
      background-size: 590px 320px;
      .icon_img {
        margin-top: 48px;
        margin-left: 175px;
        width: 240px;
        height: 240px;
      }
      .icon_lock {
        position: absolute;
        right: 40px;
        top: 40px;
        width: 40px;
        height: 40px;
      }
    }
    .info_box {
      position: relative;
      height: 434px;
      padding: 40px 40px 0;
      h5 {
        font-family: DiDiSans-Pro-ExtraBold;
        font-size: 40px;
        color: #0b0b0d;
        line-height: 56px;
        font-weight: normal;
        margin-bottom: 24px;
        @include ellipsis(2);
      }
      p {
        font-family: DiDiSans-Pro-Regular;
        font-size: 28px;
        color: #0b0b0d;
        line-height: 48px;
        font-weight: 400;
        @include ellipsis(4);
        &.birthday {
          @include ellipsis(3);
        }
      }
      .btn {
        position: absolute;
        bottom: 20px;
        display: inline-block;
        padding: 14px 24px;
        background: #ffe5d9;
        border-radius: 25px;
        font-family: DiDiSans-Pro-Bold;
        font-size: 28px;
        color: #ff5f14;
        line-height: 36px;
        font-weight: normal;
      }
    }
  }
  .close_btn {
    display: flex;
    justify-content: center;
    color: #fff;
    width: 100%;
    font-size: 64px;
    padding-top: 174px;
    text-align: center;
  }
}
</style>
